export default function DropDownIcon() {
  return (
    <svg width="12" height="6" fill="none" viewBox="0 0 12 6">
      <path
        stroke="#008E3E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M11.25.75L6 5.25.75.75"
      ></path>
    </svg>
  );
}
